/**
 * Список ID категорій для секції на головній (порядок і склад).
 * labelKey — ключ i18n для назви категорії (переклад в UI через t(labelKey)).
 */
export interface LandingCategoryItem {
  id: string
  labelKey: string
  bgColor: string
  image: string
  imageMobile: string
  imageAlt: string
  imageMobileAlt: string
}

export const LANDING_CATEGORY_IDS: LandingCategoryItem[] = [
  {
    id: 'biblical',
    labelKey: 'categories.Bible',
    bgColor: '#E8F4FF',
    image: '/assets/images/home-page/category/desktop/bibliia-knyha-koronari-shkiariana-paliturka.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/vidkryta-knyha-bibliia-na-blakytnomu-foni-banner.jpg',
    imageAlt: 'categories.imageAlt.biblical',
    imageMobileAlt: 'categories.imageMobileAlt.biblical',
  },
  {
    id: 'family',
    labelKey: 'categories.Family',
    bgColor: '#FFEEE5',
    image: '/assets/images/home-page/category/desktop/shchaslyva-simia-tato-mama-dytyna.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/shchaslyva-simia-tato-mama-dytyna-banner.jpg',
    imageAlt: 'categories.imageAlt.family',
    imageMobileAlt: 'categories.imageMobileAlt.family',
  },
  {
    id: 'health',
    labelKey: 'categories.Health',
    bgColor: '#E5FFF5',
    image: '/assets/images/home-page/category/desktop/zdorove-kharchuvannia-salat-smuzi-hanteli.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/zdorove-kharchuvannia-salat-smuzi-hanteli-banner.jpg',
    imageAlt: 'categories.imageAlt.health',
    imageMobileAlt: 'categories.imageMobileAlt.health',
  },
  {
    id: 'womens',
    labelKey: 'categories.Womens',
    bgColor: '#FFE5F0',
    image: '/assets/images/home-page/category/desktop/moloda-divchyna-v-dzhynsovii-sorochtsi.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/moloda-divchyna-v-dzhynsovii-sorochtsi-banner.jpg',
    imageAlt: 'categories.imageAlt.womens',
    imageMobileAlt: 'categories.imageMobileAlt.womens',
  },
  {
    id: 'youth',
    labelKey: 'categories.Youth',
    bgColor: '#FFF5E5',
    image: '/assets/images/home-page/category/desktop/moloda-para-khlopets-divchyna-jest-klas.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/moloda-para-khlopets-divchyna-jest-klas-banner.jpg',
    imageAlt: 'categories.imageAlt.youth',
    imageMobileAlt: 'categories.imageMobileAlt.youth',
  },
  {
    id: 'teenage',
    labelKey: 'categories.Teenage',
    bgColor: '#FFFBE5',
    image: '/assets/images/home-page/category/desktop/hrupa-shchaslyvykh-pidlitkiv-druzi-posmishky.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/hrupa-shchaslyvykh-pidlitkiv-druzi-posmishky-banner.jpg',
    imageAlt: 'categories.imageAlt.teenage',
    imageMobileAlt: 'categories.imageMobileAlt.teenage',
  },
  {
    id: 'childish',
    labelKey: 'categories.Childish',
    bgColor: '#F0E5FF',
    image: '/assets/images/home-page/category/desktop/divchynka-pokazuie-sertse-rukamy.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/divchynka-pokazuie-sertse-rukamy-banner.jpg',
    imageAlt: 'categories.imageAlt.childish',
    imageMobileAlt: 'categories.imageMobileAlt.childish',
  },
  {
    id: 'psychology',
    labelKey: 'categories.Psychology',
    bgColor: '#FFE5F0',
    image: '/assets/images/home-page/category/desktop/mentalne-zdorovya-divchyna-kvitkove-volossia.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/mentalne-zdorovya-divchyna-kvitkove-volossia-banner.jpg',
    imageAlt: 'categories.imageAlt.psychology',
    imageMobileAlt: 'categories.imageMobileAlt.psychology',
  },
  {
    id: 'prayer',
    labelKey: 'categories.Prayer',
    bgColor: '#E5FFF5',
    image: '/assets/images/home-page/category/desktop/cholovik-molytsia-zakryti-ochi-medytatsiia.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/cholovik-molytsia-zakryti-ochi-medytatsiia-banner.jpg',
    imageAlt: 'categories.imageAlt.prayer',
    imageMobileAlt: 'categories.imageMobileAlt.prayer',
  },
]
